export enum AdditionalCategoryTypes {
  SERVICE_BONUS = "Benefício bônus",
  PRODUCT = "Benefício combo",
  BENEFIT = "Benefício",
  OWN_DEVELOPMENT = "Desenvolvimento próprio"
}

export enum AdditionalCategoryOptionsEnum {
  SERVICE_BONUS = "SERVICE_BONUS",
  PRODUCT = "PRODUCT",
  BENEFIT = "BENEFIT",
  OWN_DEVELOPMENT = "OWN_DEVELOPMENT"
}
